import CustomerInvoice from "../../../classes/CustomerInvoice.js";
import { customerScope } from "../../../util/customerScope.js";

export const GET_CUSTOMER_INVOICE = async (
  { dispatch },
  { customerID, invoiceID }
) => {
  let path = CustomerInvoice.getPath(customerID, invoiceID);
  return dispatch("GET_DOC", {
    converter: CustomerInvoice,
    path,
    stateKey: "customerInvoices",
    id: invoiceID,
  });
};

export const GET_CUSTOMER_INVOICES = (
  { dispatch },
  { customerID, conditions, limitCount, pagination }
) => {
  return dispatch("GET_COLLECTION", {
    converter: CustomerInvoice,
    stateKey: "customerInvoices",
    path: customerID ? CustomerInvoice.getPath(customerID) : null,
    conditions,
    limitCount,
    pagination,
  });
};

export const LISTEN_CUSTOMER_INVOICE = async (
  { dispatch },
  { customerID, invoiceID, next, error, unlisten }
) => {
  return dispatch("LISTEN_DOC", {
    converter: CustomerInvoice,
    path: CustomerInvoice.getPath(customerID, invoiceID),
    stateKey: "customerInvoices",
    id: invoiceID,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_CUSTOMER_INVOICES = async (
  { dispatch, state },
  { customerID, pagination, next, error, unlisten, retain }
) => {
  return Promise.all(
    customerScope(state, customerID).map((id) =>
      dispatch("LISTEN_COLLECTION", {
        converter: CustomerInvoice,
        path: CustomerInvoice.getPath(id),
        stateKey: "customerInvoices",
        pagination,
        next,
        error,
        unlisten,
        retain,
      })
    )
  );
};
